export const PERK_BUTTON_TEST_ID = 'perk-button-test';
